import { Component, OnInit, ViewChild, TemplateRef, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../Master/user/user.service';
import { FormdashboardgrouptableService } from './formdashboardgrouptable.service';
import { NgxSpinnerService } from "ngx-spinner";
import { FormrenderService } from '../../formrender/formrender.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { FormdashboardService } from '../../dashboard/formdashboard/formdashboard.service';
import { FormconfigService } from '../../configuration/formconfig/formconfig.service';
import { DatePipe } from '@angular/common';
import { RequestconfigService } from '../../configuration/requestconfig/requestconfig.service';
import { saveFile, saveAs } from 'file-saver';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';	
import { LocalService } from '../../local.service';	
import {encryptdecrypt} from '../../encryptdecrypt';																   

import * as _ from 'lodash';
declare var $: any;


@Component({
  selector: 'app-formdashboardgrouptable',
  templateUrl: './formdashboardgrouptable.component.html',
  styleUrls: ['./formdashboardgrouptable.component.css']
})
export class FormdashboardgrouptableComponent implements OnInit {
  list: any;

  headers: any;
  UserList: any; //itemsPerPage: number = 10;
  p: number = 1;
  userid: number = 0; userRole: string = '';
  sortDirection: string = 'desc'; colkey: string = ''; searchcondition: string = ''; formConfigList: any = [];
  pageevent: boolean = false;
  columnshow: boolean = false; _columnsearchgroup: any = []; columnsearch: boolean = false;
  sortingcondition: string = '';

  _itemsPerPage: number = 10;
  isitemperpagechanged = false;
  customSearchDocumentList: any = [];
  advancedSearchId: number = 0;
  previewfilterflag: boolean = false;

	paginationLimit:Number=5; 
  showShortDesciption = true
  startPage : Number;

  paginationLimit1:Number; 
  showShortDesciption1 = true
  startPage1 : Number;					  
  rows: string[];
  searchedFormList: any = []; formSearchDetailsList: any = []; by: string = ''; searchData: string = '';

  //form render next unread record
  countConditionObj: any;
  getvaluesConditionObj: any;
  isadvancesearch = false;
  item: any;
  // private readonly table1: DatatableComponent;
  rowsData: any = []; columns: any = [];
  groupSearch: boolean = false;
  groupExpansionDefault: boolean = false;
  groupRowsBy: string = ''; selectedNodeText: string = ''; loadingIndicator: boolean = true; itemsPerPageText: number = 25;
  isSort: boolean = false;
  searchbyfielname: string = '';
  totalformdetailcountgroup: number = 3;
  _colspan: number = 0;
  initialRowDataList: any = [];
  idValue = '';
  markallcheckbox = false;
  @Output() groupbyloading = new EventEmitter();
  @Input() formconfigid: number = 0;
  @Input() selectedvalue: any;
  @Input() pagenumber: any;
  @Input() page: any;
  @Input() databaseid: any;
  @Input() databasename: any;
  @Input() searchby: any;
  @Input() formconfigname: any;
  @Input() itemsPerPage: any = 25;
  @Input() delete: boolean = false;
  @Input() selectedNodeTextValue: any;
  @Input() headergroup: any;
  @Input() columnsearchgroup: any = [];
  @Input() isSortGroupBy: boolean = false;
  @Input() sortingconditionGroupBy: any;
  @Input() sortingDirectionGroupBy: any;
  @Input() sortingconditionValueGroupBy: any;
  @Input() archiveyear: any;
  @Input() groupleveldata: any;
@Input() searchbyallocation: any;								   
	 @ViewChild('viewMenu', {static: true}) public viewMenu: ContextMenuComponent;
@ViewChild('basicMenu1', {static: true}) public basicMenu1: ContextMenuComponent;
enc=new encryptdecrypt();
  constructor(private _router: Router, private formdashboardservice: FormdashboardgrouptableService,
    private toastr: ToastrService, private userservice: UserService, private SpinnerService: NgxSpinnerService,
    private formRenderService: FormrenderService, private dialogService: DialogService,
    private _formdashboardservice: FormdashboardService, private formConfigService: FormconfigService, 
    private datePipe: DatePipe,private requestConfigService: RequestconfigService,
    private contextMenuService: ContextMenuService, private localService: LocalService
  ) {


  }

  ngOnInit() {
    if (this.headergroup != null && this.headergroup != undefined && this.headergroup != '') {
      this.headers = this.headergroup;
      this._columnsearchgroup = this.columnsearchgroup;
      this.p = this.pagenumber;
    }
    this.idValue = this.selectedvalue.toString().replace(/[^a-zA-Z0-9]+/g, '').trim(); 

    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    //this.LoadAllUserList();
    //this.LoadFormconfig();
    this.getpagepreference();
   
    console.log(this._columnsearchgroup);
   
    this.loadValues();
  
	this.columnsearchchanged();
  
    this.changeitemsperpage(this._itemsPerPage);						   
  }

  async loadValues() {
    let a= new encryptdecrypt(); 
    await Promise.all([this.userservice.Get().toPromise(), this._formdashboardservice.getFormConfig().toPromise()]).then(
      ([result1, result2]) => {
        result1.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
        this.UserList = result1;

        if (result2 != undefined) {
          this.formConfigList = result2.filter(e => e.dbid == this.databaseid && e.active == 1);
        }
        if (this._columnsearchgroup.length > 0) {
          this.columnshow = true;
          if (this.isSortGroupBy) {
            this.sortingcondition = this.sortingconditionValueGroupBy;
          }
         
          this.loadcolumnsearchdata(this._columnsearchgroup, this.pagenumber);
        }
        else
          this.LoadSearchedFormDetails(this.pagenumber);
      }, error => { this.toastr.error('Error while getting users data') });
  }

  LoadSearchedFormDetails(pageno) {

    var searchcondition = "";
    var searchcountcondition = "";
    if (this.searchby == "All") {
      searchcountcondition = "All"
      searchcondition = "All";
      this.searchcondition = searchcondition;
      // this.loadformdetails(pageno, searchcondition, searchcountcondition);
    }
    if (this.searchby == "createdon") {
      searchcountcondition = " and cast(createdon as date)='" + this.selectedvalue.replace(new RegExp('/', 'g'), '-') + "'";
      searchcondition = " and cast(createdon as date)='" + this.selectedvalue.replace(new RegExp('/', 'g'), '-') + "'";
      this.searchcondition = searchcondition;
      // this.loadformdetails(pageno, searchcondition, searchcountcondition);
    }
    else if (this.searchby == "createdby") {
      searchcountcondition = " and createdby=" + this.getUserid(this.selectedvalue);
      searchcondition = " and createdby=" + this.getUserid(this.selectedvalue);
      // this.loadformdetails(pageno, searchcondition, searchcountcondition);
    }

    else {
      this.searchbyfielname = this.searchby;
      searchcondition = " and " + this.searchbyfielname.trim() + "='" + this.selectedvalue + "'";
      searchcountcondition = " and " + this.searchbyfielname.trim() + "='" + this.selectedvalue + "'";
      this.searchcondition = searchcondition;
      //  this.loadformdetails(pageno, searchcondition, searchcountcondition);


      //this.formdashboardservice.getformsearchdetailsfieldname(this.formconfigid).toPromise().then((res) => {
      //  //  console.log(res);
      //  var data = [];
      //  if (res != undefined && res != null && res.length != 0) {
      //    this.formSearchDetailsList = JSON.parse(res.body.count);

      //  }
      //}, error => { this.toastr.error('Error while getting search details list') });

    }


    if (this.isSortGroupBy) {
      this.colkey = this.sortingconditionGroupBy;
      this.sortDirection = this.sortingDirectionGroupBy == 'asc' ? 'desc' : 'asc';
      this.searchcondition = searchcondition;
      this.sorting(this.sortingconditionGroupBy, '0');
    } else {
      this.loadformdetails(pageno, searchcondition, searchcountcondition);
    }



  }

  loadformdetails(pageno, searchcondition, searchcountcondition) {
  
    this.SpinnerService.show();
    this.searchcondition = searchcondition;
    this.headers = []; this.initialRowDataList = [];
    let allFormConfigData: any = []; let _documentList: any = [];
    let input: any = [];
    input.push({
      'formconfigid': this.formconfigid, 'searchcondition': searchcountcondition, 'groupleveldata': '', 'archiveyear': this.archiveyear
    });
    this.countConditionObj = input[0];
    this.formdashboardservice.getAllFormDocumentDetailscount(input[0]).toPromise().then(
      (res) => {
        //this.totalformdetailcountgroup = res.count;
        this.totalformdetailcountgroup = res.body.count;
        if (res.body.count > 0) {

          if (this.totalformdetailcountgroup != 0) {
            let obj: any = [];
            obj.push({
              'formconfigid': this.formconfigid, 'pageno': pageno, 'itemsperpage': this.itemsPerPageText, 'searchcondition': searchcondition, 'userid': this.userid, 'groupleveldata': '', 'archiveyear': this.archiveyear
            })
            this.getvaluesConditionObj = obj[0];
            this.isadvancesearch = false;
            this.formdashboardservice.getAllFormDocumentDetails(obj[0]).toPromise().then(
              async (res) => {
                // console.log(res);
                if (res != undefined && res != null && res.length != 0) {
                  //this.rowsData = [];
                  _documentList = JSON.parse(res.body[0].j);
                  if (_documentList != undefined && _documentList != null && _documentList.length != 0) {
                    _documentList.map(function (obj) { delete obj.createdby; delete obj.createdon; delete obj.formconfigid });
                    this.headers = [];
                    //let formConfigField = await this.getFormDisplayField(this.formconfigid);
                    //let html = formConfigField.filter(x => x.displaystatus == 1);
                    //html.forEach(element => {
                    //  element['label'] = element.name;
                    //});
                    var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
                    let htmldata = htmlvalue;//html.length > 0 ? html : htmlvalue;
                    var _headers = Object.keys(_documentList[0]);
                    this.headers = [];
                    _headers.forEach(i => {
                      if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                        && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                        && (i.toString() != "groupname")
                        && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                        && (i.toString() != "requestdetails") && (i.toString() != "vieweduserdetails")
                        && (i.toString() != "eutitletooltip")
                      ) {
                        var f = htmldata.filter(e => e.label == i && (i.toString() != "eutitletooltip"))[0].type;
                        if (f.length != 0) {
                          this.headers.push({
                            columnname: i,
                            columntype: f,
                            searchname: ''
                          });
                        }
                        else {
                          this.headers.push({
                            columnname: i,
                            columntype: 'text',
                            searchname: ''
                          });
                        }
                      }

                    });
                    this._colspan = this.headers.length
                    var list = _documentList;

                    this.initialRowDataList = list;
                    this.rowsData = list;
                    this.rowsData.forEach(element => {
                      if (element.read) {
                        element['isReadCheck'] = null;
                      } else {
                        element['isReadCheck'] = false;
                      }
                    });

                    var decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                    if (decissiondateindex !== -1) {
                      var allocationobj = this.headers.find(e => e.columnname === 'Allocation');
                      this.headers = this.headers.filter(e => e.columnname != 'Allocation');
                      decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                      this.headers.splice(decissiondateindex + 1, 0, allocationobj);
                    }

                    this.groupbyloading.emit("loaded");
                    this.SpinnerService.hide();
                  }
                  else {
                    this.headers = [];
                    this.rowsData = [];
                    this.SpinnerService.hide();
                  }

                }
                else {
                  this.headers = [];
                  this.rowsData = [];
                  this.SpinnerService.hide();
                }

              });
          }
          else {
            this.headers = [];
            this.rowsData = [];
            this.SpinnerService.hide();
          }
        }
        else {

          this.SpinnerService.hide();
          this.headers = [];
          this.rowsData = [];
        }
      }


    );

  }

  getformSearchDetailsList() {

  }

  _getSearchFieldsName(byName) {
    var resulttxt = '';
    if (this.formSearchDetailsList != undefined && this.formSearchDetailsList != null && this.formSearchDetailsList.length != 0) {


      var searchfields = this.formSearchDetailsList[0].formsearchdetails.split(',');
      if (searchfields != undefined && searchfields != null && searchfields.length != 0) {
        searchfields.forEach(i => {
          var j = i.split('*');
          if (j.length != 0) {
            if (byName == j[1].trim()) {
              //if (j[0].trim() == 'Created By' || j[0].trim() == 'Created On')
              resulttxt = j[0].trim();
              //else {
              //resulttxt = byName;
              //}
            }
          }
        });
      }

    }
    return resulttxt;
  }

  getPagegroup(page: number, selected: string) {
    //if (this.sortingcondition == '') {
    //  this.pagenumber = page;
    //  if (this.columnshow == true)
    //    this.loadcolumnsearchdata(this._columnsearchgroup, this.pagenumber);
    //  else
    //    this.LoadSearchedFormDetails(page);
    //}
    //else {
    //  this.pagenumber = page;
    //  this.pageevent = true;
    //  this.sorting(this.colkey, 1);
    //}



    this.p = page;
    this.pagenumber = this.p;
    this.markallcheckbox = false;
    if (this.sortingcondition == '') {

      if (this.columnshow == true) {
        if (this._columnsearchgroup != undefined && this._columnsearchgroup.length != 0) {
         
          this.loadcolumnsearchdata(this._columnsearchgroup, this.pagenumber);
        }
        else {
          this.LoadSearchedFormDetails(page);
        }
      }
      else {
        this.LoadSearchedFormDetails(page);
      }
    }
    else {
      this.pageevent = true;
      this.sorting(this.colkey, 1);
    }
  }

  openFormRender(item: any) {
 
    var database = this.databaseid + '*' + this.databasename;
    this._router.navigate(['/home/formrender'],
      {
        queryParams: { 'formDB': this.enc.encryptUsingAES256(database.toString()),//database, 
        'data': this.enc.encryptUsingAES256(item["documentid"].toString()),//item["documentid"], 
        'formConfigId': this.enc.encryptUsingAES256(this.formconfigid.toString()),//this.formconfigid,
         'archiveyear': this.enc.encryptUsingAES256(this.archiveyear.toString())//this.archiveyear 
        }
      });
  }

  // ViewFormRender(item: any) {
  //   var database = this.databaseid + '*' + this.databasename;'
  //   this._router.navigate(['/home/formrender'],
  //     {
  //       queryParams: { 'formDB': database, 'data': item["documentid"], 'formConfigId': this.formconfigid, 'mode': 'View' }
  //     });
  // }

  opennewtab(event){

    let database = this.databaseid + '*' + this.databasename;
    let queryParams = {};
    queryParams['db'] =this.enc.encryptUsingAES256(this.databaseid.toString());
    queryParams['formDB'] =this.enc.encryptUsingAES256(database.toString());
    queryParams['data'] =this.enc.encryptUsingAES256(event.item['documentid'].toString());
    queryParams['formConfigId'] = this.enc.encryptUsingAES256(this.formconfigid.toString());
    queryParams['mode'] = this.enc.encryptUsingAES256('newtab');
    event.item["read"]=true;  
        const navigationExtras: NavigationExtras = {
       queryParams,   
     
     };
    let url = this._router.createUrlTree(['/home/formrender'], navigationExtras);
    window.open('#' + url.toString(), '_blank');
  
 
  }

  ViewFormRender(item: any) {
    let database = this.databaseid + '*' + this.databasename;
    let queryParams = {};
    queryParams['db'] =this.enc.encryptUsingAES256(this.databaseid.toString());
    queryParams['formDB'] =this.enc.encryptUsingAES256(database.toString());
    queryParams['data'] =this.enc.encryptUsingAES256(item['documentid'].toString());
    queryParams['formConfigId'] = this.enc.encryptUsingAES256(this.formconfigid.toString());
    queryParams['mode'] = this.enc.encryptUsingAES256('View');


    const navigationExtras: NavigationExtras = {
      queryParams,
      state: {
        db: this.databaseid,
        formDB: database,
        data: item["documentid"],
        formConfigId: this.formconfigid,
        mode: 'View',
        page: this.page,
        selectedgroup: this.searchby,
        searchdata: this.selectedvalue,
        itemsPerPage: this.itemsPerPage,
        selectedNodeText: this.selectedNodeTextValue,
        subPage: this.pagenumber,
        itemsPerPagesub: this._itemsPerPage,
        columnsearchname: JSON.stringify(this.headers),
        columnsearchgroup: JSON.stringify(this._columnsearchgroup),
        isSortGroupBy: this.isSortGroupBy,
        sortingconditionGroupBy: this.colkey,
        sortingDirectionGroupBy: this.sortDirection,
        sortingconditionValueGroupBy: this.sortingcondition,
        archiveyear: this.archiveyear,
        groupleveldata: this.groupleveldata,
       // countConditionObj: JSON.stringify(this.countConditionObj),
        //getvaluesConditionObj: JSON.stringify(this.getvaluesConditionObj),
        //isadvancesearch: this.isadvancesearch
      }
    };
    this._router.navigate(['/home/formrender'], navigationExtras);

  }
  getUserid(username) {
    var userid = '';
     let a= new encryptdecrypt(); 
    if(((this.UserList == undefined) && (this.UserList.length > 0))){
      this.userservice.Get().toPromise().then(res => {  
       res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
        this.UserList = res;
      
        if ((this.UserList != undefined) && (this.UserList.length != 0)) {
          var s = this.UserList.filter(e => (e.lastname + ", " + e.firstname + '(' + e.emailid + ')') == username);
          if ((s != undefined) && (s.length != 0)) {
            userid = s[0].userid;
          }
        }
        return userid;
      }, error => { this.toastr.error('Error while getting users data') });
    }else{
      if ((this.UserList != undefined) && (this.UserList.length != 0)) {
        var s = this.UserList.filter(e => (e.lastname + ", " + e.firstname + '(' + e.emailid + ')') == username);
        if ((s != undefined) && (s.length != 0)) {
          userid = s[0].userid;
        }
      }
      return userid;
    }
   
  }
  getDocumentStatus(statusData, formList) {
    if (statusData.length != 0) {
      formList.forEach((item, index) => {
        var exists = statusData.filter(e => e.documentid == item['Document ID'] && e.readstatus == 1)
        if (exists != undefined && exists != null && exists.length != 0)
          formList[index]['read'] = true;
        else
          formList[index]['read'] = false;
      });
    }
    else {
      formList.forEach((item, index) => {
        formList[index]['read'] = false;
      });
    }
    return formList;

  }
  LoadAllUserList() {
    let a= new encryptdecrypt(); 
    this.userservice.Get().toPromise().then(res => {
      // console.log(res);
        res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
      
      this.UserList = res;
      this.LoadSearchedFormDetails(1);

    }, error => { this.toastr.error('Error while getting users data') });

  }

  removeFormDocument(item) {
    // console.log(item);
    var _inputData = [];
    _inputData.push(
      {
        'formconfigid': this.formconfigid,
        'tablename': this.formconfigname.replace(' ', '').toLowerCase(),
        'documentid': item['documentid'],
        'createdby': this.userid
      })

    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to remove this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.formRenderService.Delete(_inputData[0]).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success("Record deactivated successfully");
                this.LoadSearchedFormDetails(this.p);
              }
            }, error => {
              // console.log(error);
              this.toastr.error(error);
            });
        }
      });
  }
  LoadFormconfig() {
    this._formdashboardservice.getFormConfig().subscribe(
      (res) => {
        if (res != undefined) {
          this.formConfigList = res.filter(e => e.dbid == this.databaseid && e.active == 1);
        }
      });
  }

  async sorting(col, val) {
   
    this.isSortGroupBy = true;
    //if (val == 0)
    //  this.sortingcondition == '';
    if (this.colkey != col)
      this.sortingcondition == '';
    let _sortedList: any = [];
    var sortingCondition = '';
    if (this.sortingcondition == '' || this.pageevent != true)
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    if (this.formConfigList != undefined && this.formConfigList != null && this.formConfigList.length != 0) {
      //let formConfigField = await this.getFormDisplayField(this.formconfigid);
      //let html = formConfigField.filter(x => x.displaystatus == 1);
      //html.forEach(element => {
      //  element['label'] = element.name;
      //});
      var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
      let htmldata = htmlvalue;//html.length > 0 ? html : htmlvalue;
      //var htmldata = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
      if (htmldata.length != 0) {
        var u = htmldata.filter(e => e.label == col && e.type != 'select' && e.type != 'checkbox-group' && e.type != 'radio-group')
        //  if (u.length != 0) {
        this.SpinnerService.show();
        this.colkey = col;
        var s = htmldata.filter(e => e.label == col)[0].formcontrolname.toLowerCase()
        if (s != null && s != undefined && s != '') {
          sortingCondition = s + ' ' + this.sortDirection;
          this.sortingcondition = sortingCondition;
        }




        let obj: any = [];
      
        if (this._columnsearchgroup == '') {

          let input: any = [];
          input.push({ 'formconfigid': this.formconfigid, 'searchcondition': this.searchcondition, 'groupleveldata': '', 'archiveyear': this.archiveyear });
          this.countConditionObj = input[0];
          this.formdashboardservice.getAllFormDocumentDetailscount(input[0]).toPromise().then(
            (res) => {
              //this.totalformdetailcountgroup = res.count;
              this.totalformdetailcountgroup = res.body.count;
              if (res.body.count > 0) {

                if (this.totalformdetailcountgroup != 0) {


                  obj.push({
                    'formconfigid': this.formconfigid, 'pageno': this.p, 'itemsperpage': this.itemsPerPageText, 'searchcondition': this.searchcondition, 'userid': this.userid, 'sorting': sortingCondition, 'groupleveldata': '', 'archiveyear': this.archiveyear
                  });
                  this.getvaluesConditionObj = obj[0];
                  this.isadvancesearch = false;
                  this._formdashboardservice.getAllFormDocumentDetailsSorting(obj[0]).subscribe(res => {
                    if (res != undefined && res != null && res.length != 0) {
                      this.rowsData = [];
                      _sortedList = JSON.parse(res.body[0].j);
                      if (_sortedList != undefined && _sortedList != null && _sortedList.length != 0) {
                        _sortedList.map(function (obj) { delete obj.createdby; delete obj.createdon; delete obj.formconfigid });
                        var htmldata = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
                        var _headers = Object.keys(_sortedList[0]);
                        this.headers = [];
                        _headers.forEach(i => {
                          if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                            && (i.toString() != 'read')
                            && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                            && (i.toString() != "requestdetails") && (i.toString() != "vieweduserdetails")  
                            && (i.toString() != "eutitletooltip")
                          ) {
                            
                            var f = htmldata.filter(e => e.label == i && (i.toString() != "eutitletooltip"))[0].type;
                            if (f.length != 0) {
                              this.headers.push({
                                columnname: i,
                                columntype: f,
                                searchname: ''
                              });
                            }
                            else {
                              this.headers.push({
                                columnname: i,
                                columntype: 'text',
                                searchname: ''
                              });
                            }
                          }

                        });
                        /*   this.headers = Object.keys(_sortedList[0]);
                           if (this.headers.length != 0) {
                             this.columns = [];
                             this.headers.forEach(i => {
                               this.columns.push({
                                 name: i, prop: i
                               });
                             })
                           }*/
                        var decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                        if (decissiondateindex !== -1) {
                          var allocationobj = this.headers.find(e => e.columnname === 'Allocation');
                          this.headers = this.headers.filter(e => e.columnname != 'Allocation');
                          decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                          this.headers.splice(decissiondateindex + 1, 0, allocationobj);
                        }

                        this._colspan = this.headers.length
                        var list = _sortedList;
                        this.rowsData = [];
                        this.rowsData = list;
                        this.rowsData.forEach(element => {
                          if (element.read) {
                            element['isReadCheck'] = null;
                          } else {
                            element['isReadCheck'] = false;
                          }
                        });

                        this.SpinnerService.hide();
                      }
                    }
                    this.pageevent = false;
                  }, error => { this.SpinnerService.hide(); this.pageevent = false; });
                  //  }
                }
              }
            });
        }
        else {
          this.columnsearchchanged();
        }
      }
    }

  }

  async getFormDisplayField(id) {
    return await this.formConfigService.getFormConfigDisplayField(id).toPromise().then(res => res);
  }

  async columnsearchchanged() {
 
if(this.columnsearchgroup != undefined && this._columnsearchgroup.length !=0 && this.columnsearchgroup!='' ){
  this.loadcolumnsearchdata(this._columnsearchgroup, this.pagenumber);
}
else {
    var conditionname = '';
    var conditionvalue = '';
    var count = 0;
    var fieldsList = [];
    var fieldsname = ''; var tablename = '';
    this.markallcheckbox = false;
    //let formConfigField = await this.getFormDisplayField(this.formconfigid);
    this._formdashboardservice.getFormConfig().toPromise().then(
      (result) => {
        if (result != undefined) {
          this.formConfigList = [];
          this.formConfigList = result.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid);
        }
        if (this.formConfigList != undefined && this.formConfigList != null && this.formConfigList.length != 0) {
          this.columnsearch = true;


          //let html = formConfigField.filter(x => x.displaystatus == 1);
          //html.forEach(element => {
          //  element['label'] = element.name;
          //});

          var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
          let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
          // var htmldata = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
          if (htmldata != undefined && htmldata != null && htmldata.length != 0) {
            htmldata.forEach(i => {
              if (i.type != 'hidden' && i.type != 'header' && i.type != 'paragraph') {
                count = 0;
                for (var col of this.headers) {
                  if (i.label == col.columnname) {
                   // conditionvalue = $("#columnsearch_" + count).val();
                    conditionvalue = $("#columnsearch_" + count + "_" + this.idValue).val();
                    this.headers['searchname'] = conditionvalue;
                    if (conditionvalue != '' && conditionvalue != undefined) {
                      fieldsname = i.name.trim();
                      if (i.tablename != undefined && i.tablename != null) {
                        tablename = i.tablename.trim();
                      }
                      else {
                        tablename = '';
                      }

                      if (i.type != 'date') {
                        fieldsList.push({
                          tablename: tablename,
                          fieldsname: i.formcontrolname.trim(),
                          condition: 'contains',
                          fieldstype: i.type.trim(),
                          label: i.label.trim(),
                          value: conditionvalue
                        });
                      }
                      else {
                        fieldsList.push({
                          tablename: '',
                          fieldsname: i.formcontrolname.trim(),
                          condition: 'between',
                          fieldstype: i.type.trim(),
                          label: i.label.trim(),
                          value: conditionvalue
                        });
                      }
                      break;
                    }
                  }
                  count = count + 1;
                }
              }
            });
          }
          if (this.searchby == "createdon") {
            fieldsList.push({
              tablename: '',
              fieldsname: 'cast(createdon as date)',
              condition: 'between',
              fieldstype: 'date',
              label: '',
              value: this.selectedvalue.replace(new RegExp('-', 'g'), '/') + '-' + this.selectedvalue.replace(new RegExp('-', 'g'), '/')
            });
          }
          else if (this.searchby == "createdby") {
            fieldsList.push({
              tablename: '',
              fieldsname: this.searchby,
              condition: 'equals',
              fieldstype: '',
              label: '',
              value: this.getUserid(this.selectedvalue)
            });
          }
          else {
            var groupData = this.selectedvalue.split(':');
            var groupBy = this.searchby.split('-');
            if (groupData.length >= 2) {
              groupData.forEach((i, ind) => {
                var htmlAllData = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
                var h = htmlAllData.filter(e => e.formcontrolname.toLowerCase() == groupBy[ind].toLowerCase());
                if (ind == 0) {
                  fieldsList.push({
                    tablename: h[0].tablename,
                    fieldsname: h[0].formcontrolname.trim(),
                    condition: 'in',
                    fieldstype: h[0].type.trim(),
                    label: h[0].label.trim(),
                    value: i
                  });
                }
                if (ind == 1) {
                  fieldsList.push({
                    tablename: h[0].tablename,
                    fieldsname: h[0].formcontrolname.trim(),
                    condition: 'contains',
                    fieldstype: h[0].type.trim(),
                    label: h[0].label.trim(),
                    value: i
                  });
                }

              });
            }
            else {
              var htmlAllData = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
              var s = htmlAllData.filter(e => e.formcontrolname.toLowerCase() == this.searchby.toLowerCase() && e.tablename != undefined);
              if (s.length != 0) {
                fieldsList.push({
                  tablename: s[0].tablename,
                  fieldsname: s[0].name.trim(),
                  condition: 'equals',
                  fieldstype: s[0].type.trim(),
                  label: s[0].label.trim(),
                  value: this.selectedvalue
                });
              }
              else {
                fieldsList.push({
                  tablename: '',
                  fieldsname: this.searchby,
                  condition: 'contains',
                  fieldstype: '',
                  label: '',
                  value: this.selectedvalue.replace(new RegExp('-', 'g'), '/')
                });
              }
            }
          }

          this._columnsearchgroup = [];
          this._columnsearchgroup.push({
            fieldsname: '',
            fieldscondition: fieldsList,
            formconfigid: this.formconfigid
          });
          console.log(this._columnsearchgroup);
         
          this.loadcolumnsearchdata(this._columnsearchgroup, 1);
        }
      
      });
    }
  }


  loadcolumnsearchdata(_columnsearchgroup, pagenumber) {
   
    this.SpinnerService.show();
    var advancedSearchIdNumber = 0;
    let formdata: any = [];
    formdata.push({
      advancedSearchId: advancedSearchIdNumber,
      pageno: this.p,
      itemsperpage: this.itemsPerPageText,
      userid: this.userid,
      fieldscondition: JSON.stringify(_columnsearchgroup[0])
    });
    this._formdashboardservice.getFormConfig().subscribe(
      (result) => {
        if (result != undefined) {
          this.formConfigList = [];
          this.formConfigList = result.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid);
        }
        this.countConditionObj = formdata[0];
        
        this._formdashboardservice.getformadvancedsearchdetailscount(formdata[0]).subscribe(res => {
          if (res != undefined && res != null) {
            this.totalformdetailcountgroup = JSON.parse(res.body[0].formdetails)[0].count;
          }

          //if (this.totalformdetailcountgroup != 0) {
          let data: any = [];
          if (this.sortingcondition == '') {
            data.push({
              advancedSearchId: advancedSearchIdNumber,
              pageno: this.p,
              userid: this.userid,
              itemsperpage: this.itemsPerPageText,
              fieldscondition: JSON.stringify(_columnsearchgroup[0])
            });
          }
          else {
            data.push({
              advancedSearchId: advancedSearchIdNumber,
              pageno: this.p,
              userid: this.userid,
              itemsperpage: this.itemsPerPageText,
              fieldscondition: JSON.stringify(_columnsearchgroup[0]),
              sorting: this.sortingcondition
            });
          }
          this.getvaluesConditionObj = data[0];
          this.isadvancesearch = true;
          this._formdashboardservice.getformadvancedsearchdetails(data[0]).subscribe(
            async (res) => {
              if (res != undefined && res.length != 0 && res.body[0].formdetails != null) {
                let _searchDocumentList: any = [];
                _searchDocumentList = JSON.parse(res.body[0].formdetails);
                this.formconfigid = _searchDocumentList[0].formconfigid;
                // this.formConfigName = _searchDocumentList[0]['Form Name'];
                this.formconfigname = this.selectedNodeText;
                if ((_searchDocumentList != undefined) && (_searchDocumentList.length != 0)) {
                  //let formConfigField = await this.getFormDisplayField(this.formconfigid);
                  //let html = formConfigField.filter(x => x.displaystatus == 1);
                  //html.forEach(element => {
                  //  element['label'] = element.name;
                  //});
                  var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
                  let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
                  // var htmldata = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseid && e.active == 1 && e.formconfigid == this.formconfigid)[0].htmldata);
                  var _headers = Object.keys(_searchDocumentList[0]);
                  console.log(_headers);
                  var searchList = [];
                  searchList = this.headers;// this.headers.filter(e => e.columnname!=undefined);
                  this.headers = [];
                  _headers.forEach(i => {
                    if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                      && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                      && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                      && (i.toString() != "requestdetails") && (i.toString() != "vieweduserdetails")
                      && (i.toString() != "eutitletooltip")
                    ) {
                      var f = htmldata.filter(e => e.label == i && (i.toString() != "eutitletooltip"))[0].type;
                      if (f.length != 0) {
                        this.headers.push({
                          columnname: i,
                          columntype: f,
                          searchname: ''
                        });
                      }
                      else {
                        this.headers.push({
                          columnname: i,
                          columntype: 'text',
                          searchname: ''
                        });
                      }
                    }

                  });

                  if (this.headers.length != 0) {
                    this.headers.forEach((i, ind) => {
                      if ((i.columnname.toString() != 'documentid')
                        && (i.columnname.toString() != "Created By") && (i.columnname.toString() != "Created On")
                        && (i.columnname.toString() != 'read') && (i.columnname.toString() != 'Form Name')
                        && (i.columnname.toString() != 'formconfigid')
                        && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                        && (i.toString() != "requestdetails") && (i.toString() != "vieweduserdetails")
                        && (i.toString() != "eutitletooltip")
                      ) {
                        if (searchList.filter(e => e.columnname != undefined && e.columnname == i.columnname).length != 0) {
                          if (searchList.filter(e => e.columnname == i.columnname)[0].searchname != '') {
                            var a = searchList.filter(e => e.columnname == i.columnname)[0].searchname;
                            if (a != null) {
                              if (a.length != 0) {
                                // this.headers[ind]['searchname'] = a;

                                if (searchList.filter(e => e.columntype == i.columntype)[0].columntype != 'date') {
                                  this.headers[ind]['searchname'] = a;
                                }
                                else {
                                  var datearray = [];
                                  datearray = a;
                                  if (datearray.length == 2) {
                                    let datestring: string = "";
                                    datestring = this.datePipe.transform(datearray[0], "MM/dd/yyyy") + ' - ' + this.datePipe.transform(datearray[1], "MM/dd/yyyy");
                                    this.headers[ind]['searchname'] = datestring;
                                  }
                                  else {
                                    this.headers[ind]['searchname'] = a;
                                  }
                                }

                              }
                              //if (searchList.filter(e => e.columntype == i.columntype)[0].columntype == 'date') {
                              //  if (a.length != 0) {
                              //    this.headers[ind]['searchname'] = this.datePipe.transform(a[0].split[0], "MM/dd/yyyy") + this.datePipe.transform(a[1].split[1], "MM/dd/yyyy");

                              //  }
                              //}
                              //else {
                              //  if (a.length != 0) {
                              //    this.headers[ind]['searchname'] = a;

                              //  }
                              //}
                            }
                          }
                        }
                      }

                    });
                    var decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                    if (decissiondateindex !== -1) {
                      var allocationobj = this.headers.find(e => e.columnname === 'Allocation');
                      this.headers = this.headers.filter(e => e.columnname != 'Allocation');
                      decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                      this.headers.splice(decissiondateindex + 1, 0, allocationobj);
                    }

                  }

                  this.rowsData = [];
                  //after data get cleaned up check the user read document status
                  if (_searchDocumentList.length != 0) {
                    this.rowsData = _searchDocumentList;
                    this.rowsData.forEach(element => {
                      if (element.read) {
                        element['isReadCheck'] = null;
                      } else {
                        element['isReadCheck'] = false;
                      }
                    });

                    this.groupSearch = false;
                    this.SpinnerService.hide();
                  }
                }
              }
              else {
                // this.toastr.error('No preview data found');
                this.rowsData = [];
                this.groupSearch = false;
                this.SpinnerService.hide();
              }

            },
            err => {
              this.toastr.error('Not able to get preview data');
              this.SpinnerService.hide();
              this.rowsData = [];
            });
          //}
          //else
          //{

          //            this.SpinnerService.hide();
          //            this.rowsData = [];
          //}
        });
      });

  }

  columnsearchshowhide() {
    if (this.columnshow == true)
      this.columnshow = false;
    else
      this.columnshow = true;
  }
  columnsearchcancel() {
    this.columnshow = false;
    this.isSortGroupBy = false;
    this.LoadSearchedFormDetails(1);
  }

  keypress(eve) {
    if (eve.keyCode == 13) {
      this.columnsearchchanged();
    }
  }


  updateMyDate(eve) {
    this.columnsearchchanged();
  }

 fileDownload(item, filename) {
    this.SpinnerService.show();
    if (item != undefined && item != null) {
      let fileData: any = [];
      fileData.push({
        'documentId': item["documentid"], 'dbName': this.databasename, 'formConfigId': this.formconfigid, 'fileName': filename
      });
      this.requestConfigService.DownloadFormFile(fileData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, filename);
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });
    }
  }


  splitFilename(fileNames: string) {    
    return fileNames.split(/(?<=\.[a-z]+);/g)
    //return fileNames.split(';');
  } 
  DownloadFormFileAsZip(item) {
    console.log(item);
    this.SpinnerService.show();
    if (item != undefined && item != null) {
      var fileName = this.formconfigname + '_' + item['documentid'];
      let fileData: any = [];
      fileData.push({
        'documentId': item['documentid'], 'dbName': this.databasename, 'formConfigId': this.formconfigid, 'fileName': fileName
      });

      this.requestConfigService.DownloadFormFileAsZip(fileData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, fileName + '.zip');
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });
    }
  }

  download(obj) {
    this.headers.forEach(element => {
      if (element.columntype == 'file' && obj[element.columnname] != null) {
        let a = this.splitFilename(obj[element.columnname]);
        if (a.length > 1) {
          this.DownloadFormFileAsZip(obj);
        } else {
          this.fileDownload(obj, a[0]);
        }
      }
    });


  }

  showRequestConfig(message: any, requestTypeId) {
    this._router.navigate(['/home/requestconfig'],
      { queryParams: { 'db': this.enc.encryptUsingAES256(this.databaseid.toString()), 
      'documentId': this.enc.encryptUsingAES256(message.item["documentid"].toString()),
       'formConfigId': this.enc.encryptUsingAES256(this.formconfigid.toString()),
        'requesttypeid': this.enc.encryptUsingAES256(requestTypeId.toString()),
        'formName': this.enc.encryptUsingAES256(this.formconfigname.toString()) } });
  }


  markassread(event) {
    if (!event.item['read']) {
      this.SpinnerService.show();
      var documentStatus = [];

      documentStatus.push({
        'formconfigid': this.formconfigid,
        'documentid': +event.item["documentid"],
        'readstatus': 1,
        'createdby': this.userid
      });
      this._formdashboardservice.insertDocumentStatus(documentStatus[0]).subscribe(res => {
        if (res != undefined) {
          if (res.body != 0) {
            // this.loadcolumnsearchdata(this._columnsearchgroup, this.p);
            // this.Loadformdetails(this.p);
            this.LoadSearchedFormDetails(this.p);
            this.toastr.success('Form updated successfull');
            this.SpinnerService.hide();
            // this.columnsearchchanged();
          }
        }
      }, err => {
        this.SpinnerService.hide();
        this.toastr.error('Error while updating the status');
      });
    } else {
      this.SpinnerService.hide();
      this.toastr.warning('This document is already read');
    }
  }


  markassreadall() {
    this.SpinnerService.show();
    var documentStatus = [];
    let docids = [];
    this.rowsData.forEach(element => {
      if (element.isReadCheck) {
        docids.push({ id: element.documentid });
      }
    });

    if (docids.length > 0) {
      documentStatus.push({
        'formconfigid': this.formconfigid,
        'documentid': JSON.stringify(docids),
        'readstatus': 1,
        'createdby': this.userid
      });
      this._formdashboardservice.insertDocumentReadStatus(documentStatus[0]).subscribe(res => {
        if (res != undefined) {
          if (res.body != 0) {
            // this.loadcolumnsearchdata(this._columnsearchgroup, this.p);
            // this.Loadformdetails(this.p);
            this.LoadSearchedFormDetails(this.p);
            this.toastr.success('Form updated successfull');
            this.SpinnerService.hide();
            // this.columnsearchchanged();
          }
        }
      }, err => {
        this.SpinnerService.hide();
        this.toastr.error('Error while updating the status');
      });
    } else {
      this.SpinnerService.hide();
      this.toastr.warning('Please select atleast one docment');
    }
  }

  checkAllUnread(event) {
    this.rowsData.forEach(element => {
      if (element.isReadCheck != null) {
        element.isReadCheck = event.currentTarget.checked;
      }
    });
  }

  getSelectedIds() {
    let docids = [];
    this.rowsData.forEach(element => {
      if (element.isReadCheck) {
        docids.push({ id: element.documentid });
      }
    });
    return docids;
  }
  checkreadchange(event) {
    let readcheckboxcount = this.rowsData.filter(x => x.isReadCheck != null);
    let readcheckcount = this.rowsData.filter(x => x.isReadCheck == true);
    if (readcheckboxcount.length == readcheckcount.length) {
      this.markallcheckbox = true;
    } else {
      this.markallcheckbox = false;
    }
  }
public onContextMenuView($event: KeyboardEvent, item: any): void {
    this.contextMenuService.show.next({
      anchorElement: $event.target,
      // Optional - if unspecified, all context menu components will open
      contextMenu: this.viewMenu,
      event: <any>$event,
      item: item,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }								   
  public onContextMenu($event: KeyboardEvent, item: any): void {
    this.contextMenuService.show.next({
      anchorElement: $event.target,
      // Optional - if unspecified, all context menu components will open
      // contextMenu: this.contextMenu,
      contextMenu: this.basicMenu1,
      event: <any>$event,
      item: item,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }	
changeitemsperpage(eve) {
    this.itemsPerPageText = eve;
    this._itemsPerPage = eve;
    this.markallcheckbox = false;
    if (this.isitemperpagechanged) {
      this.addpagepreference(eve);
    }

    if (this.rowsData.length != 0 && this.customSearchDocumentList.length == 0) {
      this.getPage(this.p);

    }
    // if (this.customSearchDocumentList.length != 0 && this.rowsData.length == 0) {
    //   this.getCustomPage(this.p);

    // }

  }


  addpagepreference(value) {
    let model = {
      userid: this.userid,
      pagename: 'formdashboardgroup',
      itemsperpage: value
    };

    this._formdashboardservice.addpagepreferencedetails(model).toPromise().then(res => {
      console.log('res: ', res);

    });
  }


  getPage(page: number) {
    this.p = page;
    // this.markallcheckbox = false;
    // this.pageevent = true;
    // this.columnshow = true;
    // if (this.sortingcondition != '') {
    //   this.sorting(this.colkey, 1);
    // }
    this.loadformdetails(page, this.searchcondition,this.searchcondition);
    // if (this.sortingcondition == '') {
    //   if (this.columnshow == true) {
    //     // this.loadcolumnsearchdata(this._columnsearchgroup, this.p);
    //     if (this._columnsearchgroup != undefined && this._columnsearchgroup.length != 0) {
    //       this.loadcolumnsearchdata(this._columnsearchgroup, this.p);
    //     }

    //     else {
    //       this.loadformdetails(page, this.searchcondition, this.searchcondition);
    //       if (this.advancedSearchId == 0) {
    //         if (this.previewfilterflag == false)
    //           this.loadformdetails(page, this.searchcondition, this.searchcondition);
    //         else{}
    //        //   this.previewFilter(page);
    //       }
    //       else {
    //      //   this.showAdvancedSearch(this.advancedSearchId, this.p, this.sortingcondition);
    //       }
    //     }
    //   }
    //   else {

    //     // if (this.advancedSearchId == 0) {
    //     //   if (this.previewfilterflag == false)
    //     //     this.Loadformdetails(page);
    //     //   else
    //     //     this.previewFilter(page);
    //     // }
    //     // else {
    //     //   this.showAdvancedSearch(this.advancedSearchId, this.p, this.sortingcondition);
    //     // }
    //   }
    // }

  }

  getCustomPage(page: number) {
    if (this.sortingcondition == '') {
      this.p = page;
      if (this.customSearchDocumentList.length != 0 && this.rowsData.length == 0){}
      //  this.showAdvancedSearch(this.advancedSearchId, page, null);
    }
    else {
      this.p = page;
      this.pageevent = true;
      // this.sortingcusto(this.colkey, 1);
    }
  }						   
  showMoreItems(value, $event, item) {
    this.item = item;
    // this.paginationLimit = Number(this.paginationLimit) + value;        
    //this.paginationLimit =+this.paginationLimit + 5;
    this.paginationLimit = 15;
    $event.preventDefault();
    $event.stopPropagation();
  }
  showLessItems(value, $event, item) {
    this.item = item;
    this.paginationLimit = value > 5 ? 5 : value;
    $event.preventDefault();
    $event.stopPropagation();
  }
   alterDescriptionText() {
    this.showShortDesciption = !this.showShortDesciption
 }


  showMoreItems1(value, $event, item) {
    this.item = item;
    //  this.paginationLimit = Number(this.paginationLimit) + value;        
   // this.paginationLimit1 = +this.paginationLimit1 + 5;
   this.paginationLimit1 = 15;
    $event.preventDefault();
    $event.stopPropagation();
  }
  showLessItems1(value, $event, item) {
    this.item = item;
    this.paginationLimit1 = value > 5 ? 5 : value;
    $event.preventDefault();
    $event.stopPropagation();
  }


 alterDescriptionText1() {
  this.showShortDesciption1 = !this.showShortDesciption1
  }

  async getpagepreference() {
    let model = {
      userid: this.userid,
      pagename: 'formdashboardgroup'
    };
    await this._formdashboardservice.getpagepreferencedetails(model).toPromise().then(res => {
      
      if (res != null) {
        let data = JSON.parse(res[0].j);
        this._itemsPerPage = data[0].itemsperpage == undefined || data[0].itemsperpage == null ? this._itemsPerPage : data[0].itemsperpage;
        this.itemsPerPageText = this._itemsPerPage;
      }

    });
  }

 viewrequest(request) {
    // let a = request.requestid + '*' + request.requesttypeid
    // this.router.navigate(['/home/requestconfig'], { queryParams: { requestid: request.requestid, requesttypeid: request.requesttypeid, redirectmode: 'viewrequest' } })
    let a = request.requestid + '*' + request.requesttypeid;
    let queryParams = {};
    queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());//request.requestid;
    queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());
    queryParams['redirectmode'] = this.enc.encryptUsingAES256('viewrequest');
    // const navigationExtras: NavigationExtras = {
    //   queryParams
    // };
    // this.router.navigate(['/home/requestconfig'], navigationExtras);
    let url = this._router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank');
  }

  
}
